
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { css } from 'aphrodite';

import PanelHeader from './PanelHeader';
import PanelFooter from './PanelFooter';

import styles from './styles.js';


class FullScreenPanel extends Component {
    static propTypes = {
        children: PropTypes.node,
        hasFooter: PropTypes.bool,
        onClose: PropTypes.func,
        toggleFullScreenPanel: PropTypes.func.isRequired
    }

    static defaultProps = {
        hasFooter: false
    }

    componentWillUnmount() {
        const { onClose } = this.props;
        onClose();
    }

    clearAllFilters = () => {

    }

    handleCancel = () => {
        const { toggleFullScreenPanel } = this.props;
        this.setState({ isCancelled: true }, () => {
            toggleFullScreenPanel();
        });
    }

    render() {
        const {
            clearAllFilters,
            handleApply,
            handleCancel
        } = this;
        const {
            children,
            hasFooter
        } = this.props;
        return (
            <div>
                <div className={css(styles.outerContainer)}>
                    <div className={css(styles.panel)}>
                        <PanelHeader
                            handleClose={handleCancel}
                            headerAction={clearAllFilters}
                        />
                        <div
                            className={
                                hasFooter ?
                                    css(
                                        styles.panelContent,
                                        styles.panelContent_full,
                                        styles.panelContent_withFixedHeader,
                                        styles.panelContent_withFooter
                                    ) :
                                    css(
                                        styles.panelContent,
                                        styles.panelContent_full,
                                        styles.panelContent_withFixedHeader
                                    )
                            }
                        >
                            <div className={css(styles.panelBody)}>
                                {children}
                            </div>
                        </div>
                        {
                            hasFooter ?
                                <PanelFooter
                                    handleButtonClick={handleApply}
                                /> : null
                        }
                    </div>
                </div>
            </div>
        );
    }
}

export default FullScreenPanel;



// WEBPACK FOOTER //
// ./src/components/Header/MoveableDiv/SearchBar/SearchBarSmall/SearchBarPanel/FullScreenPanel/FullScreenPanel.jsx